// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3_8Pw","title":"Images90_title__2vwFt","images":"Images90_images__12EX0"};